<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import CartYoubookWidget from '@/components/cart/v2/CartYoubookWidget.vue';
import { i18n } from '@/shared-instance.ts';

i18n.install(getCurrentInstance()!.appContext.app);
</script>

<template>
  <CartYoubookWidget />
</template>
